import type { FC } from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const ClearIcon: FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0003 2L8.66699 7.66667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.29715 7.39026C4.64359 8.02453 3.32179 7.91573 2 7.39233C2.33373 11.6873 4.33609 13.3393 7.00593 14C7.00593 14 9.0174 12.5776 9.30733 9.20493C9.33873 8.83966 9.35447 8.65706 9.27853 8.45126C9.20253 8.24546 9.05347 8.09786 8.75527 7.80266C8.26487 7.31713 8.01967 7.07439 7.7286 7.01359C7.4376 6.95286 7.05747 7.09866 6.29715 7.39026Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10.9643C3 10.9643 4.66667 11.2857 6.33333 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66667 4.83333C5.66667 5.29357 5.29357 5.66667 4.83333 5.66667C4.37309 5.66667 4 5.29357 4 4.83333C4 4.37309 4.37309 4 4.83333 4C5.29357 4 5.66667 4.37309 5.66667 4.83333Z"
      stroke={color}
    />
    <path
      d="M7.33301 2.66797V2.73464"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
